import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useMutation } from '@tanstack/react-query'
import { trpc } from '@/main'
import * as v from 'valibot'
import { Spinner } from '@/components/ui/spinner'
import { CenteredSpinnerPending } from './-components/app-layout-skeleton'

export const Route = createFileRoute('/_app/checkout')({
  validateSearch: v.object({
    productId: v.optional(v.string()),
    customerId: v.optional(v.string()),
    productType: v.fallback(v.optional(v.picklist(['subscription', 'payment']), 'subscription'), 'subscription'),
  }),
  component: RouteComponent,
  pendingComponent: CenteredSpinnerPending,
})

function RouteComponent() {
  const { productId, customerId, productType } = Route.useSearch()
  const { mutateAsync: retrieveBillingIntent, isPending } = useMutation(trpc.billing.retrieveIntent.mutationOptions())

  useEffect(() => {
    if (!productId || !customerId) return

    retrieveBillingIntent({ productId, productType, customerId }).then(({ sessionUrl }) => {
      window.location.href = sessionUrl
    })
  }, [retrieveBillingIntent, customerId, productId, productType])

  if (isPending) return <Spinner />
}
